<template>
  <div class="dialog-wrap">
    <el-dialog title="QQ群编辑"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="480px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="100px">
        <el-form-item label="群名称"
                      prop="name">
          <el-input v-model="dataForm.name"
                    placeholder="请输入群名称"></el-input>
        </el-form-item>
        <el-form-item label="群号码"
                      prop="number">
          <el-input v-model="dataForm.number"
                    placeholder="请输入群号码"></el-input>
        </el-form-item>
        <el-form-item label="管理员"
                      prop="manager">
          <el-input v-model="dataForm.manager"
                    placeholder="请输入群管理员号码"></el-input>
        </el-form-item>
        <el-form-item label="院校"
                      prop="college_code">
          <el-select v-model="dataForm.college_code"
                     filterable
                     remote
                     reserve-keyword
                     placeholder="请输入关键词"
                     :remote-method="fetchCollegeList"
                     :loading="loading"
                     style="width:100%;">
            <el-option v-for="item in collegeList"
                       :key="item.code"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业">
          <el-select v-model="major"
                     filterable
                     remote
                     reserve-keyword
                     placeholder="请输入关键词"
                     :remote-method="fetchMajorList"
                     :loading="loading"
                     style="width:100%;">
            <el-option v-for="(item, index) in majorList"
                       :key="index"
                       :label="`（${item.code}）${item.name}`"
                       :value="{ value: item.code, label: item.name }">
              <span>{{ `（${item.code}）${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="适合科目："
                      prop="subjects">
          <div class="tag-wrap">
            <el-tag class="subject-item"
                    size="medium"
                    :key="item.id"
                    v-for="item in subjects"
                    closable
                    :disable-transitions="false"
                    @close="handleSubjectRemove(item)">
              {{
                  item.college_name
                    ? `${item.college_name}-${item.name}`
                    : item.name
                }}
            </el-tag>
            <el-button type="text"
                       @click="handleSubjectChoose">选择科目</el-button>
          </div>
        </el-form-item>
        <el-form-item label="群链接"
                      prop="description">
          <el-input v-model="dataForm.link_url"
                    placeholder="请输入群链接"></el-input>
        </el-form-item>
        <el-form-item label="群描述"
                      prop="description">
          <el-input v-model="dataForm.description"
                    placeholder="请输入群描述"></el-input>
        </el-form-item>
        <el-form-item label="排序值"
                      prop="sort">
          <el-input v-model="dataForm.sort"
                    placeholder="请输入排序值，纯数字"></el-input>
        </el-form-item>
        <el-form-item label="在线状态"
                      prop="status">
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <SubjectChoose :visible="subjectChooseDialog"
                   :subjects="subjects"
                   @close="subjectChooseDialog = false"
                   @submit="saveSubject"></SubjectChoose>
  </div>
</template>

<script>
import { qqGroupUpdate } from '@/api/operation'
import { collegeList, majorList } from '@/api/common'
import SubjectChoose from '@/components/dialog/subject/SubjectChoose'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: {
    SubjectChoose,
  },
  data() {
    return {
      major: null,
      subjects: [],
      subjectChooseDialog: false,
      dialogVisible: this.visible,
      dataForm: this.content || {},
      loading: false,
      collegeList: [],
      majorList: [],
      rules: {
        name: [{ required: true, message: '请输入群名称', trigger: 'blur' }],
        description: [
          { required: false, message: '请输入群描述', trigger: 'blur' },
        ],
        number: [{ required: true, message: '请输入群号码', trigger: 'blur' }],
        manager: [
          { required: true, message: '请输入群管理员号码', trigger: 'blur' },
        ],
        college_code: [
          { required: true, message: '请输入院校名称', trigger: 'blur' },
        ],
        sort: [
          { required: true, message: '请输入排序值，纯数字', trigger: 'blur' },
        ],
        status: [
          { required: false, message: '请设置上线状态', trigger: 'change' },
        ],
      },
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      this.dataForm = val
      if (val.college) {
        this.collegeList = [val.college]
      }
      console.log(val)
      this.majorList = [
        {
          code: val.major_code,
          name: val.major_name,
        },
      ]
      this.major = {
        label: val.major_name,
        value: val.major_code,
      }

      this.subjects = val.subject_codes.split(',').map((code, index) => ({
        code: code,
        name: val.subject_names.split(',')[index] || '',
      }))
    },
  },
  methods: {
    handleSubjectRemove(item) {
      this.subjects = this.subjects.filter((v) => v.code !== item.code)
    },
    handleSubjectChoose() {
      this.subjectChooseDialog = true
    },
    saveSubject({ subjects }) {
      this.subjects = subjects
      console.log(this.subjects, '科目')
    },
    fetchCollegeList(query) {
      this.loading = true
      collegeList({ keyword: query, isPaging: 0 }).then((res) => {
        if (res) {
          this.collegeList = res.list
        }
        this.loading = false
      })
    },

    fetchMajorList(query) {
      this.loading = true
      majorList({ keyword: query, isPaging: 0, combine: 0 }).then((res) => {
        if (res) {
          this.majorList = res.list
        }
        this.loading = false
      })
    },

    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = {
            id: this.dataForm.id,
            name: this.dataForm.name,
            description: this.dataForm.description,
            college_code: this.dataForm.college_code,
            number: this.dataForm.number,
            manager: this.dataForm.manager,
            sort: this.dataForm.sort,
            status: this.dataForm.status ? 1 : 0,
            link_url: this.dataForm.link_url,
            major_code: this.major.value,
            major_name: this.major.label,
            subject_codes: this.subjects.map((item) => item.code).join(','),
            subject_names: this.subjects.map((item) => item.name).join(','),
          }
          qqGroupUpdate(params)
            .then((res) => {
              this.$message.success(`更新成功`)
              this.$refs['dataForm'].resetFields()

              this.$emit('submit')
              this.handleClose()
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}
</style>
